import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { EventTypes } from 'src/app/core/constants/event-types';
import { SendTypes } from '../../../../../core/api/models';
import { CreatePrivateNumberSendLimitCommand } from '../../../../../core/api/models/create-private-number-send-limit-command';
import { GetPrivateNumberSendLimitByIdDto } from '../../../../../core/api/models/get-private-number-send-limit-by-id-dto';
import { UpdatePrivateNumberSendLimitCommand } from '../../../../../core/api/models/update-private-number-send-limit-command';
import { OrganizationsService } from '../../../../../core/api/services/organizations.service';
import { PrivateNumberSendLimitService } from '../../../../../core/api/services/private-number-send-limit.service';
import { PrivateNumbersService } from '../../../../../core/api/services/private-numbers.service';
import {
  DialogService,
  DialogStatus,
} from '../../../../../core/services/dialog.service';
import { BaseFormPageComponent } from '../../../../shared/base/components/base-form-page.component';
import { FormPageConfig } from './../../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';


@Component({
    selector: 'app-private-number-send-limit-form',
    templateUrl: './private-number-send-limit-form.component.html',
    imports: [BaseFormModule]
})
export class PrivateNumberSendLimitFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  protected currentService = inject(PrivateNumberSendLimitService);
  pageVocabs = 'pages.assignNumbers.privateNumberSendLimit.form.';
  formPageConfig: FormPageConfig<GetPrivateNumberSendLimitByIdDto> = {};

  model: CreatePrivateNumberSendLimitCommand = {};
  get SendTypes() {
    return SendTypes;
  }

  @Input() usersId: number = 0;

  //#endregion

  constructor(
    public organizationService: OrganizationsService,
    public privateNumberService: PrivateNumbersService,
    public dialogService: DialogService
  ) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.changeFormValidations();

      if (!this.model?.userIds) this.model.userIds = [];
      if (this.usersId) this.model.userIds?.push(this.usersId);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  initForm() {
    this.form = new FormGroup({
      userIds: new FormControl(''),
      sendTypesList: new FormControl(''),
      privateNumberIds: new FormControl(''),
      userName: new FormControl(''),
      privateNumber: new FormControl(''),
      canSeeReceivedSms: new FormControl(''),
    });
  }

  changeFormValidations() {
    try {
      if (this.formPageConfig.isEditMode) {
        this.form.controls['privateNumber'].disable();
        this.form.controls['userName'].disable();
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }
  //#region Api

  //Create
  baseCreateApi(model: CreatePrivateNumberSendLimitCommand) {
    this.unSubs();

    this.loading = true;
    this.currentService
      .privateNumberSendLimitCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdatePrivateNumberSendLimitCommand) {
    this.unSubs();

    this.loading = true;

    model.id = this.formPageConfig.editId;

    this.currentService
      .privateNumberSendLimitUpdatePut({
        body: model,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion
  onSubmit() {
    if (this.loading) return;
    if (!this.formPageConfig.isEditMode) {
      if (!this.model.privateNumberIds) {
        this.dialogService.openDialog({
          title: 'common.error',
          message: 'messages.requiredPrivateNumbers',
          status: DialogStatus.error,
        });
        return;
      } else if (!this.model.userIds) {
        this.dialogService.openDialog({
          title: 'common.error',
          message: 'messages.requiredUserIds',
          status: DialogStatus.error,
        });
        return;
      }
    }

    try {
      this.checkCreateOrUpdate();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }
}
